import { IMenuItem } from 'types/IMenuItem';
import homeIcon from 'assets/icons/sidebar/home.svg';
import aboutIcon from 'assets/icons/sidebar/about.svg';
import skillsIcon from 'assets/icons/sidebar/skills.svg';
import projectsIcon from 'assets/icons/sidebar/projects.svg';
import experienceIcon from 'assets/icons/sidebar/experience.svg';
import educationIcon from 'assets/icons/sidebar/education.svg';
import certificationsIcon from 'assets/icons/sidebar/certifications.svg';

const MENU_ITEMS = [
  {
    link: '/',
    title: 'Home',
    icon: homeIcon,
  },
  {
    link: '/about',
    title: 'About',
    icon: aboutIcon,
  },
  {
    link: '/skills',
    title: 'Skills',
    icon: skillsIcon,
  },
  {
    link: '/projects',
    title: 'Projects',
    icon: projectsIcon,
  },
  {
    link: '/experience',
    title: 'Experience',
    icon: experienceIcon,
  },
  {
    link: '/education',
    title: 'Education',
    icon: educationIcon,
  },
  {
    link: '/certifications',
    title: 'Certifications',
    icon: certificationsIcon,
  },
] satisfies IMenuItem[];

export default MENU_ITEMS;
